const Success = () => {
  return (
    <div className="flex flex-col space-y-6 items-center justify-center p-32">
      <svg className="w-32 h-32" viewBox="0 0 126 126" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="63" cy="63" r="63" fill="#EAFBEE" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M93 45.7288L52.945 90L33 70.0062L40.065 62.9239L52.592 75.4816L85.5992 39L93 45.7288Z"
          fill="#4CBC94"
        />
      </svg>
      <span className="text-4xl">Huddle Requested</span>
    </div>
  );
};

export default Success;
